export default {
  user: {
    locked: 'Votre compte est verrouillé, veuillez contacter le CIEM',
    coordonne: 'Coordonnées',
    securite: 'Sécurité',
    name: 'Utilisateur',
    search: {},
    details: {
      mail: 'Mail',
      portable: 'Téléphone portable',
      question: 'Question secrète',
      dateNaissance: 'Date de naissance',
      roleCorrespondant:
        "Cochez cette case UNIQUEMENT si vous êtes correspondant d'entreprise",
    },
    infoPersonnelles: 'Informations personnelles',
    infoProfessionnelles: 'Informations professionnelles',
    infoAdresse: 'Adresse',
    infoEtablissement: 'Établissements',
  },
}
